import Image from 'next/image'

import { cn } from '../../lib/utils'
import { CornerBrackets } from './CornerBrackets'

const BRAND_MARK_SRC = '/brand/cloud-shuttle-mark-512.png'

/** Dot grid — decorative background only (≤15% effective opacity via CSS). */
export function KineticDotGrid({ className }: { className?: string }) {
  return <div className={cn('kinetic-hero-grid', className)} aria-hidden />
}

/** Large brand mark behind content; never use mix-blend on this layer. */
export function KineticBrandMarkBackdrop({
  className,
  markClassName = 'opacity-[0.09]',
  maxWidthClass = 'max-w-[min(72vw,520px)]',
}: {
  className?: string
  markClassName?: string
  maxWidthClass?: string
}) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-0 flex items-center justify-center',
        className
      )}
      aria-hidden
    >
      <div className={cn('relative aspect-square w-full', maxWidthClass, markClassName)}>
        <Image
          src={BRAND_MARK_SRC}
          alt=""
          fill
          className="object-contain"
          sizes="(max-width: 768px) 80vw, 520px"
        />
      </div>
    </div>
  )
}

/** Foreground mission visual: bounded panel, alt text, caption (F-02 layering rule). */
export function KineticMissionMarkPanel({ className }: { className?: string }) {
  return (
    <figure
      className={cn(
        'border-kinetic-outline-variant/30 relative aspect-square overflow-hidden border bg-kinetic-surface-container-high',
        className
      )}
    >
      <KineticDotGrid className="opacity-50" />
      <div className="relative flex h-full flex-col items-center justify-center px-8 pb-24 pt-10">
        <Image
          src={BRAND_MARK_SRC}
          alt="Cloud Shuttle mark — cloud and rocket"
          width={200}
          height={200}
          className="object-contain drop-shadow-[0_0_40px_rgba(0,240,255,0.15)]"
          priority={false}
        />
      </div>
      <CornerBrackets />
      <figcaption className="border-kinetic-outline-variant/20 bg-kinetic-surface/90 absolute bottom-0 left-0 right-0 border-t p-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-kinetic-primary-container">
          Route // meetups → platforms → delivery
        </p>
        <p className="mt-2 text-sm leading-relaxed text-kinetic-on-surface-variant">
          The same team that organises ANZ data communities helps clients ship pipelines, platforms,
          and AI evaluation practice.
        </p>
      </figcaption>
    </figure>
  )
}
